"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeys = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
exports.getKeys = function (object) {
    return Object.keys(object);
};
